import { useRef } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, as: Tag = "span" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "112%" }}
            animate={inView ? { y: "0%" } : {}}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const ClipImage = ({ src, alt = "", className = "", imgClassName = "", parallax = 6, rounded = "rounded-3xl" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${parallax}%`, `${parallax}%`]);
  return (
    <motion.div
      ref={ref}
      initial={{ clipPath: "inset(16% 10% 16% 10% round 32px)", opacity: 0.5 }}
      animate={inView ? { clipPath: "inset(0% 0% 0% 0% round 24px)", opacity: 1 } : {}}
      transition={{ duration: 1.3, ease: EASE }}
      className={`relative overflow-hidden ${rounded} ${className}`}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y }}
        className={`w-full h-full object-cover scale-[1.14] will-change-transform ${imgClassName}`}
      />
    </motion.div>
  );
};
